import { HttpErrorResponse } from '@angular/common/http';
import { CDate, ICalendarDay, IOrder, IReservation } from '@curbnturf/entities';
import { createAction, props } from '@ngrx/store';

export enum OrderActionTypes {
  OrderError = '[Order] Order Load Error',
  PriceError = '[Order] Price Load Error',
  RequestPrice = '[Order] Requesting Price',
  PriceFilled = '[Order] Price Filled',
  RequestDays = '[Order] Fill the Calendar Days',
  DaysFilled = '[Order] Calendar Days Filled',
  SetDays = '[Order] Set Order Days',

  // new and used actions
  SetOrder = '[Order] Set Local Order Process',
  SetOrderSite = '[Order] Set Site On Order Process',
}

export const orderError = createAction(
  OrderActionTypes.OrderError,
  props<{ error: HttpErrorResponse }>(),
);

export const priceError = createAction(
  OrderActionTypes.PriceError,
  props<{ error: HttpErrorResponse }>(),
);

export const requestPrice = createAction(
  OrderActionTypes.RequestPrice,
  props<{ reservation: IReservation }>(),
);

export const priceFilled = createAction(
  OrderActionTypes.PriceFilled,
  props<{ reservation: IReservation }>(),
);

export const requestDays = createAction(
  OrderActionTypes.RequestDays,
  props<{ siteId: number; reservationId?: number }>(),
);

export const setDays = createAction(
  OrderActionTypes.SetDays,
  props<{ dateRange: CDate }>(),
);

export const daysFilled = createAction(
  OrderActionTypes.DaysFilled,
  props<{ days: ICalendarDay[] }>(),
);

export const setOrder = createAction(
  OrderActionTypes.SetOrder,
  props<{ order?: IOrder }>(),
);

export const setOrderSite = createAction(
  OrderActionTypes.SetOrderSite,
  props<{ siteId: number | undefined }>(),
);
